import React from 'react';

import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { CHART_COLORS } from './Chart.constants';
import {
  customDividerStyles,
  getChartInfoStyles,
  getChartSegmentStyles,
  getIndicatorStyles,
  tooltipStyles,
} from './Chart.styles';
import ChartInfo from './ChartInfo';

const defaultArray = [];

const tooltipProps = {
  tooltip: {
    sx: tooltipStyles,
  },
};

const ChartSegment = ({
  percentage = 0,
  color,
  info = defaultArray,
  isHiddenInfo = false,
  tooltipConfig = defaultArray,
}) => {
  const isTooltipInfo = color === CHART_COLORS.ORANGE || color === CHART_COLORS.YELLOW;

  const tooltipContent = (
    <div className="flex gap-24">
      {tooltipConfig.map(({ color, info }, index) => (
        <div className="flex gap-24" key={`${color}-info-${index}`}>
          <div className="flex gap-12">
            <div style={getIndicatorStyles({ color })} />
            <div className="flex flex-col gap-4">
              {info.map((item, index) => (
                <ChartInfo key={`${color}-field-${index}`} {...item} />
              ))}
            </div>
          </div>
          {tooltipConfig.length > 1 && index === 0 && <div style={customDividerStyles} />}
        </div>
      ))}
    </div>
  );

  const content = (
    <div style={getChartSegmentStyles({ percentage, color, isHover: isTooltipInfo })}>
      {!isTooltipInfo && !isHiddenInfo && (
        <div style={getChartInfoStyles({ color, isTooltipInfo, percentage })}>
          {info.map((item, index) => (
            <ChartInfo key={index} {...item} />
          ))}
        </div>
      )}
    </div>
  );

  return isTooltipInfo ? (
    <Tooltip placement="top" slotProps={tooltipProps} title={tooltipContent}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

ChartSegment.propTypes = {
  color: PropTypes.string.isRequired,
  percentage: PropTypes.number,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  isHiddenInfo: PropTypes.bool,
  tooltipConfig: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      info: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          value: PropTypes.string,
        }),
      ),
    }),
  ),
};

export default ChartSegment;
